module.exports = __webpack_public_path__ + "static/media/add student enquiry and staff enquiry.db6a519b.svg";